import {cloneDeep, isArray, isPlainObject} from "lodash";
import Vue from "vue";
import { EDGE_OF_BOARD } from "@/store/game/constants";

const columns = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I'];
const rows = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

export function setDeepState(state, newState) {
  console.log('setDeepState Called', Object.keys(state));

  Object.keys(state).forEach((key) => {
    const newVal = newState[key];
    if (isArray(newVal)) {
      Vue.set(state, key, newVal);
      return;
    }

    if (!isPlainObject(newVal)) {
      Vue.set(state, key, newVal);
      return;
    }

    setDeepState(state[key], newVal);
  });
}

export function getStartingTiles() {
  const tiles = [];
  columns.forEach(column => {
    rows.forEach(row => {
      tiles.push(`${column}${row}`);
    });
  });

  return tiles;
}

export function getAdjacentTiles(tileId) {
  const column = tileId.slice(0, 1);
  const row = Number(tileId.slice(1));

  const columnIndex = columns.indexOf(column);
  const rowIndex = rows.indexOf(row);

  const top = getColumn(columnIndex - 1, row) || EDGE_OF_BOARD;
  const bottom = getColumn(columnIndex + 1, row) || EDGE_OF_BOARD;
  const left = getRow(rowIndex - 1, column) || EDGE_OF_BOARD;
  const right = getRow(rowIndex + 1, column) || EDGE_OF_BOARD;

  return {
    top,
    bottom,
    left,
    right,
  };
}

function getColumn(columnIndex, row) {
  const column = columns[columnIndex];
  if (!column) {
    return null;
  }

  return `${column}${row}`;
}

function getRow(rowIndex, column) {
  const row = rows[rowIndex];
  if (!row) {
    return null;
  }

  return `${column}${row}`;
}

export function getPriceAndBonus(hotel, count) {
  const multiplier = getPriceMultiplier(count);
  const firstBonus = hotel.startingMajorityBonus + (hotel.majorityBonusAddend * multiplier);
  return {
    price: hotel.startingPrice + (hotel.priceAddend * multiplier),
    firstBonus,
    secondBonus: firstBonus / 2,
  }
}

export const HOTEL_SIZE_RANGES = [
  { low: 2, high: 2 },
  { low: 3, high: 3 },
  { low: 4, high: 4 },
  { low: 5, high: 5 },
  { low: 6, high: 10 },
  { low: 11, high: 20 },
  { low: 21, high: 30 },
  { low: 31, high: 40 },
  { low: 41, high: null },
];

function getPriceMultiplier(count) {
  if (count <= 2) {
    return 0;
  } else if (count === 3) {
    return 1;
  } else if (count === 4) {
    return 2;
  } else if (count === 5) {
    return 3;
  } else if (count >= 6 && count <= 10) {
    return 4;
  } else if (count >= 11 && count <= 20) {
    return 5;
  } else if (count >= 21 && count <= 30) {
    return 6;
  } else if (count >= 31 && count <= 40) {
    return 7;
  } else if (count >= 41) {
    return 8;
  }
}

export function getRandomTile(tiles) {
  const _tiles = cloneDeep(tiles);
  const randomTile = Math.floor(Math.random()*_tiles.length);
  const tile = _tiles.splice(randomTile, 1);
  return {
    tile: tile[0],
    tiles: _tiles,
  }
}
